import { Link } from "react-router-dom";
import type { Work } from "@/mocks/works";
import { categoryBySlug } from "@/mocks/categories";

export default function WorkCard({ work }: { work: Work }) {
  const cat = categoryBySlug(work.category);
  return (
    <Link
      to={`/work/${work.id}`}
      className="group block cursor-pointer overflow-hidden rounded-lg border border-background-200/60 bg-background-100 transition-colors hover:border-accent-300/50"
    >
      <div className="relative aspect-[5/7] w-full overflow-hidden bg-background-200">
        <img
          src={work.cover}
          alt={`${work.title}漫画封面`}
          title={`${work.title}漫画在线阅读`}
          loading="lazy"
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-full bg-background-950/80 px-2.5 py-1 text-xs font-medium text-accent-300 backdrop-blur-sm">
          {work.status}
        </span>
        <span className="absolute right-2 top-2 rounded-full bg-primary-500/90 px-2.5 py-1 text-xs font-semibold text-background-50">
          {work.rating.toFixed(1)}
        </span>
        <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-background-950/90 to-transparent"></div>
        <div className="absolute bottom-2 left-2 right-2 flex items-center justify-between text-xs text-foreground-200">
          <span>
            <i className="ri-eye-line mr-1" aria-hidden="true"></i>
            {work.views}
          </span>
          <span>{work.updateLabel}</span>
        </div>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="truncate text-sm font-semibold text-foreground-100 md:text-base">
          {work.title}
        </h3>
        <div className="mt-2 flex items-center gap-2">
          {cat && (
            <span className="rounded-full bg-secondary-500/20 px-2 py-0.5 text-xs text-secondary-200">
              {cat.name}
            </span>
          )}
          <span className="truncate text-xs text-foreground-500">
            {work.author}
          </span>
        </div>
      </div>
    </Link>
  );
}